export const defaultTextPlaceHolder = '@default@';
export const urlSubmitString = '_submit_id';
export const jsbTypeString = '_jsb_type';
export const prefillDataString = '_prefill_data';
export const imgCdnHostPrefix =
  'https://p16-feelgood-sg.ibyteimg.com/tos-alisg-i-x0dqkltuhb-sg/newfeelgood/';

export const imgCdnHostSuffix = '~tplv-x0dqkltuhb-original.image';
